import { sbMsgBusInstance } from "./mbus";
import { GeneralTopics } from "./MessageBusTopics/General";
import { GeoTopics, GeoMessageSenderId } from "./MessageBusTopics/GeoComply";
import { BettingSlipTopics } from "./MessageBusTopics/BettingSlip";
export * from "./MessageBusTopics";
export const sbMsgBusPredefinedTopics = {
    BettingSlipTopics,
    GeneralTopics,
    GeoTopics,
    GeoMessageSenderId
};
window["sbMsgBus"] = sbMsgBusInstance;
// TODO: OFTL-115
window["sbMsgBus"]["sbMsgBusPredefinedTopics"] = sbMsgBusPredefinedTopics;
window["sbMsgBusPredefinedTopics"] = sbMsgBusPredefinedTopics;
export const sbMsgBus = sbMsgBusInstance;
//# sourceMappingURL=index.js.map